<app-list-header (toggleFilter)="onToggleFilter()">
  <ng-container top>
    <div
      class="display-flex ion-align-items-center ion-justify-content-between"
    >
      <div *ngIf="!p.renderMobile">
        <ion-button
          routerLink="/app/booking/add-room"
          size="medium"
          *appHasRole="['room.add']"
          class="menu-header-button"
        >
          <ion-icon name="add" slot="start"></ion-icon>
          <ion-label>{{ "SPACE.ROOM.ADD" | translate }}</ion-label>
        </ion-button>

        <ion-button
          *appHasRole="['equipment.view']"
          routerLink="/app/equipment/1"
          size="medium"
          color="light"
          class="menu-header-button"
        >
          <ion-icon name="add" slot="start"></ion-icon>
          <ion-label>
            {{ "SPACE.ROOM.EQUIPMENT_M" | translate }}
          </ion-label>
        </ion-button>
      </div>
      <app-search-bar
        (searchEvent)="onChangeSearch($event)"
        [ngClass]="{ 'w-100': p.renderMobile }"
      >
      </app-search-bar>
    </div>
  </ng-container>
  <ng-container bottom>
    <app-space-filter [spaceType]="type" showCapacity="true">
    </app-space-filter>
    <div
      class="select-with-images__eqipment-filter-container"
      *ngIf="!p.renderMobile && parsedEquipments.length > 0"
    >
      <ion-label> {{ "EQUIPMENT.CHOOSE" | translate }}</ion-label>
      <app-select-buttons
        [keyValueList]="parsedEquipments"
        defaultSelectedValue="666"
        [multiple]="true"
        [outline]="true"
        (selectedChange)="onFilterEquipment($event)"
      >
      </app-select-buttons>
    </div>
  </ng-container>
</app-list-header>

<ion-grid *ngIf="!isImagesDisplay" class="horizontal-margin-minus-10">
  <ion-row>
    <ion-col
      class="ion-no-padding"
      sizeLg="6"
      size-xl="4"
      sizeMd="6"
      sizeXs="12"
      sizeSm="6"
      *ngFor="let item of filteredItems"
    >
      <div
        class="select-with-images__element"
        (click)="onClicked(item[itemValueField])"
      >
        <div
          class="select-with-images__element-image"
          [ngClass]="{ 'select-with-images__default-image': !item.image }"
        >
          <img
            [ngClass]="{ 'select-with-images__custom-image': item.image }"
            [src]="item.image ? item.image.filePath : defaultImage"
          />

          <div class="select-with-images__equipment-container">
            <ion-chip
              *ngFor="let equipment of item.equipments"
              disabled
              class="select-with-images__equipment"
            >
              <ion-icon
                *ngIf="equipment.iconName && equipment.iconName != 'null'"
                [src]="
                  '../../assets/icons/equipment/' + equipment.iconName + '.svg'
                "
                color="primary"
              ></ion-icon>
              <ion-label>{{ equipment.name }}</ion-label>
            </ion-chip>
          </div>

          <ion-chip
            disabled
            class="select-with-images__space-capacity"
            *ngIf="item.capacity"
          >
            <ion-icon name="people-outline"></ion-icon>
            <ion-label>{{ item.capacity }}</ion-label>
          </ion-chip>
        </div>

        <div class="select-with-images__content-container">
          <div>
            <div class="select-with-images__content-header">
              {{ item[itemTextField] }}
            </div>
            <div class="select-with-images__content-description">
              {{ item.description }}
            </div>
            <div
              *ngIf="buildingServ.buildings.length > 1"
              class="select-with-images__detail-container"
            >
              <ion-icon
                src="../../../assets/icons/building-alt.svg "
                class="add-invitation-space-view__icon"
              ></ion-icon>
              <ion-text class="select-with-images__detail">
                {{ item.floor?.building.name }}
              </ion-text>
            </div>
            <div class="select-with-images__detail-container">
              <ion-icon
                name="code"
                class="add-invitation-space-view__icon rotate-90-deg"
              ></ion-icon>
              <ion-text class="select-with-images__detail">
                {{ item.floor?.name }} ({{ item.floor?.level }})
              </ion-text>
            </div>
          </div>
          <div class="select-with-images__spacer"></div>
        </div>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
